import logo from './logo.svg';
import './App.css';
import React  from 'react';
import MessageBoard from './Pages/MessageBoard';

function App() {
  return (
     <div className="max-w-xl mx-auto mt-10">
      <MessageBoard />
    </div>
  );
}

export default App;
